import { Component } from '@angular/core';

@Component({
  selector: 'lib-network-devices',
  templateUrl: './network-devices.component.html',
  styleUrls: ['./network-devices.component.scss'],
  standalone: false
})
export class NetworkDevicesComponent {

}
